<template>
  <div class="home-content-page-v">
    <div class="content-one">
      <content-title title="数据导出"></content-title>
      <div class="output-content">
        <div class="output-content-1">
          <div class="checkbox-content">
            <span>数据存储</span>
            <a href="javascript:;" class="checkbox-one">
              <img src="~assets/checked-2.png" alt="" v-if="down1" @click="down1=false">
              <img src="~assets/unchecked-2.png" alt="" v-if="!down1" @click="down1=true">
              <div class="checkbox-label" v-if="login === 1">
                演示数据下载 <a v-if="down1" :href="down1 ? '/static/演示数据.xlsx' : ''" @click="down" class="output-btn" download="演示数据">导出到Excel</a>
              </div>
              <div class="checkbox-label" v-else>
                演示数据下载 <a v-if="down1" @click="goLgin" class="output-btn" download="演示数据">导出到Excel</a>
              </div>
            </a>
          </div>
        </div>
        <div class="m-line">
        </div>
        <div class="output-content-1">
          <div class="checkbox-content">
            <span>case存储</span>
            <a href="javascript:;" class="checkbox-one" @click="activeOutPutWayKey = outPutWayData.key" v-for="outPutWayData in outPutWays">
              <img src="~assets/checked-2.png" alt="" v-if="outPutWayData.key === activeOutPutWayKey">
              <img src="~assets/unchecked-2.png" alt="" v-else>
              <div class="checkbox-label">
                {{outPutWayData.name}}
              </div>
            </a>
            <a href="javascript:;" class="output-btn btm-btn" @click="showEditName = true" v-if="this.activeCase.status">存 储</a>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="系统提醒" :visible.sync="showEditName" size="tiny" :before-close="close">
      <el-input placeholder="" v-model="caseName">
        <template slot="prepend">Case Name</template>
      </el-input>
      <span slot="footer" class="dialog-footer">
        <a href="javascript:;" class="output-btn btm-btn" @click="showEditName = false;saveCase()" v-if="this.activeCase.status">存 储</a>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import ContentTitle from '@/components_bit/ContentTitle'
  export default {
    components: {
      ContentTitle
    },
    methods: {
      saveCase () {
        this.$store.dispatch('saveCase')
      },
      close () {
        this.showEditName = false
      },
      goLgin () {
        this.$router.push('/login')
        this.$store.dispatch('setLoginFor', '/home/output')
      }
    },
    computed: {
      login: {
        get () {
          return this.$store.getters.login
        }
      },
      caseList: {
        get () {
          return this.$store.getters.caseList
        }
      },
      caseName: {
        get () {
          return this.$store.getters.caseName
        },
        set (value) {
          this.$store.dispatch('setCaseName', value)
        }
      },
      activeCase: {
        get () {
          return this.$store.getters.activeCase
        }
      }
    },
    data () {
      return {
        showEditName: false,
        activeImportWayKey: 'demo',
        outPutWays: [{
          name: '存储至浏览器',
          key: 'browser'
        }],
        activeOutPutWayKey: 'browser',
        down1: true
      }
    }
  }
</script>

<style scoped lang="less">
  @import '../../style/base.less';
  .content-one {
    flex:1;
    display: flex;
    flex-direction: column;
    margin-bottom: 2em;
  }
  .output-btn {
    color:#fff;
    background-color: @bak-color-2;
    padding: 0.5em 1.5em;
    text-align: center;
    border-radius: 0.3em;
    letter-spacing: 0.1em;
  }
  .output-content {
    .content-shadow;
    .content-bottom-radius;
    display: flex;
    flex:1;
    padding: 2em 0;
    background-color: #fff;
  }
  .checkbox-label {
    .output-btn {
      margin-left: 3em;
    }
  }
  .btm-btn {
    margin: 1em 0 0 2em;
  }
  .m-line {
    width: 2px;
    background-color: #ccc;
    margin: 1.5em 2.2em 1.5em 0;
  }
  .output-content-1 {
    flex: 1;
    margin: 1em 2.5em 1em;
    display: flex;

  }
  .checkbox-content {
    display: flex;
    flex-direction: column;
    span {
      line-height: 1;
      font-size: 1.13em;
      padding-bottom: 0.5em;
      color: @bak-color-2;
    }
    .app-note {
      padding: 2em 0 0 2em;
      font-size: 2em;
      color: #999;
    }
  }

  .checkbox-one {
    display: flex;
    align-items: center;
    height: 3.4em;
    font-size: 1em;
    color:@bak-color-1;
    img {
      padding-right: 1em;
    }
  }
</style>



// WEBPACK FOOTER //
// output_to.vue?a69d7892